// claude-lp-fresh-comparison — FAQ accordion + sticky nav shadow
(function() {
  'use strict';
  document.querySelectorAll('.bk-faq-q').forEach(function(btn) {
    btn.addEventListener('click', function() {
      var item = this.closest('.bk-faq-item');
      var isOpen = item.classList.contains('open');
      document.querySelectorAll('.bk-faq-item').forEach(function(el) { el.classList.remove('open'); });
      if (!isOpen) item.classList.add('open');
    });
  });
  var nav = document.querySelector('.bk-nav');
  if (nav) {
    window.addEventListener('scroll', function() {
      nav.style.boxShadow = window.scrollY > 8 ? '0 2px 16px rgba(8,39,25,0.08)' : 'none';
    });
  }
})();
